import { render } from "./RotaInicial.vue?vue&type=template&id=ea2c3a9c&scoped=true"
import script from "./RotaInicial.vue?vue&type=script&lang=js"
export * from "./RotaInicial.vue?vue&type=script&lang=js"

import "./RotaInicial.vue?vue&type=style&index=0&id=ea2c3a9c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2c3a9c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon});
